import {ENDPOINT_VERSIONS} from './_endpoint-versions';

export const INFO_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/info/version`;
